/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Ft_SubInputs */

const en_vc_ft_sub = /** @type {(inputs: Vc_Ft_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Same layout, same tool names, same shortcuts. If you have used Illustrator, you can start drawing in VectorCraft straight away.`)
};

const zh_vc_ft_sub = /** @type {(inputs: Vc_Ft_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一样的布局、一样的工具名称、一样的快捷键。用过 Illustrator，就能直接上手 VectorCraft。`)
};

/**
* | output |
* | --- |
* | "Same layout, same tool names, same shortcuts. If you have used Illustrator, you can start drawing in VectorCraft straight away." |
*
* @param {Vc_Ft_SubInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_ft_sub = /** @type {((inputs?: Vc_Ft_SubInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Ft_SubInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_ft_sub(inputs)
	return zh_vc_ft_sub(inputs)
});
export { vc_ft_sub as "vc.ft.sub" }